import type { FaireProductEntity } from "../../entity_types/product";

export const p_7yt39c8hzv: FaireProductEntity = {
  token: "p_7yt39c8hzv",
  type: "product",
  name: "Matches in Tin - Nomenclature of Colors",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/2953748f76db0f629b66f107b1425a08c490840d0c3731acef653727ad08d598.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/927349384140a44d210f963b7f9a48eaa93fef27dedc7a2ec0ccc34504830084.jpeg",
    "https://cdn.faire.com/fastly/be651589d60c07900907c71b62c9c44441dc6cec9d00a89ceb6487a72a3ae8fb.jpeg",
  ],
  priceDollars: 8.5,
  description:
    'These Ridgway’s Nomenclature of Colors Safety Matches are housed in a reusable sliding lid tin inspired by the influential 1886 colour reference guide created by ornithologist Robert Ridgway. Originally developed to help describe the colours of birds, plants, and the natural world with greater precision, the beautifully arranged swatches celebrate the intersection of art, science, and colour theory.\n\nContaining 100 safety matches with multi-coloured tips, each tin features striker paper housed within a custom brass holder on the side, combining everyday practicality with timeless decorative design. The sliding lid construction adds a tactile vintage feel, while the reusable tin is designed to be refilled and enjoyed long after the matches are gone. A cheerful addition to desks, coffee tables, and creative spaces, it also makes a thoughtful gift for artists, designers, and lovers of colour and craftsmanship.\n\nContains 100 safety matches. Keep away from children, heat, sparks, and open flames. Store in a dry place.\n\nSize: 12cm H x 8.5cm W x 2.5cm D | 4.72" H x 3.35" W x 0.89" D',
  tags: [],
  msrpDollars: 19,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:37.163Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
